import { useEffect, useState, cloneElement, Children } from "react";
import { Canvas as FabricCanvas } from "fabric";
import PropTypes from "prop-types";

type Props = {
  width: number;
  height: number;
  canvasId: string;
  children: PropTypes.ReactNodeArray | PropTypes.ReactNodeLike;
  setCanvas: (fabric: FabricCanvas) => void;
};

type CanvasElementProps = {
  // undefine-able to avoid typing issues. injected by the Canvas when cloning the Canvas Element components during
  // the render step
  canvas?: FabricCanvas;
};

type InteractableCanvasElementProps = {
  /**
   * Used so the Canvas can report changes per object back up the component heirarchy
   */
  id: string;
  /**
   * Controls whether object is eventable
   */
  evented: boolean;
} & CanvasElementProps;

const Canvas = (props: Props) => {
  const [fabricCanvas, setFabricCanvas] = useState<FabricCanvas | undefined>();

  // create Fabric Canvas instance on first render
  useEffect(() => {
    console.log("canvas mount");
    const canvas = new FabricCanvas(props.canvasId, {
      width: props.width,
      height: props.height,
      renderOnAddRemove: false,
      selection: false,
    });

    setFabricCanvas(canvas);
  }, []);

  useEffect(() => {
    if (fabricCanvas) {
      fabricCanvas.setWidth(props.width);
      fabricCanvas.setHeight(props.height);
    }
  }, [props.width, props.height]);

  // call setCanvas once the fabric Canvas has been initialized. allows wrapping components
  // to access Fabric Canvas to setup event listeners, etc
  useEffect(() => {
    fabricCanvas && props.setCanvas(fabricCanvas);
  }, [fabricCanvas]);

  useEffect(() => {
    fabricCanvas && fabricCanvas.renderAll();
  });

  // clone children, inject Fabric Canvas into props. see CanvasElementProps
  const children = Children.map(props.children, (child) => {
    if (!child) return;
    //@ts-expect-error
    return cloneElement(child, {
      canvas: fabricCanvas,
    });
  });

  return (
    <>
      <canvas id={props.canvasId} width={props.width} height={props.height} />
      {/* only render children if Fabric Canvas has been initialized */}
      {fabricCanvas && children}
    </>
  );
};

export { Canvas, CanvasElementProps, InteractableCanvasElementProps };
